module.exports = __webpack_public_path__ + "static/cpe-81c3387d53053d1599d398005ec04e86.png";